import {
  getRelativeBindingContextFields,
  defineCollectionTypeReference,
} from '@packages/systems/cms/gateway/shared';

import {
  collectionListBindingContextId,
  fieldBindingContextId,
} from './identifiers';

import type {
  BindingContextRelationshipDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';
import type {Collections} from '@packages/systems/dynamo/records/CollectionRecord';

export default function defineRelationships<RootTRef, EntityTRef, ListTRef>(
  collections: Collections,
  referenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextRelationshipDef<RootTRef, EntityTRef>[] {
  const rootRelationshipsDef = {
    type: referenceBuilder.root(),
    relativeContexts: collections.reduce<string[]>((ids, collection) => {
      if (collection._id) {
        ids.push(collectionListBindingContextId(collection._id));
      }
      return ids;
    }, []),
  };

  return [
    rootRelationshipsDef,
    ...defineCollectionRelationships(collections, referenceBuilder),
  ];
}

function defineCollectionRelationships<RootTRef, EntityTRef, ListTRef>(
  collections: Collections,
  referenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextRelationshipDef<RootTRef, EntityTRef>[] {
  return collections.reduce<
    BindingContextRelationshipDef<RootTRef, EntityTRef>[]
  >((relationshipDefs, collection) => {
    if (collection._id) {
      relationshipDefs.push({
        type: referenceBuilder.entityOf(
          defineCollectionTypeReference(collection)
        ),
        relativeContexts: getRelativeBindingContextFields(collection).map(
          (field) => fieldBindingContextId(field.id, collection._id)
        ),
      });
    }
    return relationshipDefs;
  }, []);
}
